var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKreuzstiftRgbW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 998.72 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8a911;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m215.72,243.8c-10.56,7.75-22.15,13.76-34.78,18.04-12.63,4.28-25.93,6.41-39.91,6.41s-27.28-2.13-39.92-6.41c-12.63-4.28-24.22-10.28-34.78-18.04-2.84-2.08-5.57-4.26-8.21-6.55-7.16-6.2-13.58-13.16-19.24-20.86-7.75-10.53-13.75-22.11-18-34.74-4.25-12.63-6.38-25.93-6.38-39.91s2.13-27.29,6.38-39.95c4.25-12.65,10.25-24.25,18-34.78,3.17-4.32,6.58-8.39,10.22-12.24,5.24-5.55,10.97-10.6,17.19-15.18,10.53-7.74,22.12-13.74,34.78-17.99,12.66-4.25,25.97-6.38,39.95-6.38s27.29,2.13,39.94,6.38c12.66,4.25,24.25,10.25,34.78,17.99,6.21,4.58,11.94,9.64,17.19,15.18h19.18c-8.01-10.22-17.28-19.19-27.79-26.91-11.75-8.62-24.67-15.3-38.78-20.04-14.1-4.74-28.94-7.11-44.52-7.11s-30.44,2.37-44.53,7.11c-14.1,4.74-27.02,11.42-38.78,20.04-10.52,7.72-19.78,16.69-27.79,26.91-.94,1.2-1.87,2.42-2.77,3.66-8.62,11.75-15.3,24.68-20.04,38.78-4.74,14.1-7.11,28.94-7.11,44.53s2.37,30.43,7.11,44.52c4.74,14.1,11.42,27.02,20.04,38.78,3.14,4.28,6.48,8.35,10.04,12.21,6.2,6.75,13.05,12.87,20.52,18.36,11.75,8.62,24.68,15.3,38.78,20.05,14.09,4.74,28.94,7.1,44.53,7.1s30.43-2.37,44.52-7.1c14.1-4.74,27.02-11.42,38.78-20.05,7.48-5.49,14.32-11.61,20.52-18.36h-20.92c-2.64,2.29-5.37,4.47-8.21,6.55Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.24 66.98 110.36 145.19 108.89 145.19 108.89 66.98 93.37 66.98 93.37 216.96 108.89 216.96 108.89 168.27 128.38 146.44 182.57 216.96 201.38 216.96 137.89 135.67 201.53 66.98 181.24 66.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m272.07,102.79c-6.93,0-13.16,1.73-18.67,5.2-5.52,3.46-9.35,8.01-11.5,13.62h-1.1v-17.13h-14.28v112.48h14.8v-72.06c0-5.37,1.28-10.15,3.84-14.35,2.56-4.2,6.06-7.5,10.51-9.89,4.44-2.39,9.52-3.59,15.23-3.59,1.95,0,3.77.12,5.45.37,1.68.24,2.82.44,3.4.58v-15.01c-.87-.09-2.1-.16-3.66-.18-1.57-.02-2.91-.03-4.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m375.06,116.05c-4.57-4.49-9.69-7.8-15.38-9.92-5.69-2.13-11.54-3.19-17.54-3.19-9.91,0-18.6,2.5-26.07,7.51s-13.31,11.9-17.5,20.69c-4.2,8.79-6.3,18.89-6.3,30.32s2.1,21.48,6.3,30.17c4.2,8.69,10.16,15.47,17.9,20.36,7.74,4.88,16.93,7.32,27.57,7.32,7.52,0,14.25-1.2,20.17-3.59s10.89-5.65,14.87-9.78c3.98-4.13,6.85-8.72,8.6-13.8l-14.14-4.32c-1.46,3.61-3.55,6.77-6.26,9.48-2.71,2.71-6.02,4.84-9.92,6.37-3.91,1.54-8.35,2.31-13.33,2.31-7.47,0-13.98-1.72-19.51-5.16-5.54-3.44-9.84-8.34-12.89-14.68-2.82-5.88-4.32-12.8-4.53-20.73h-4.51v-12.89h4.58c.38-5.85,1.8-11.33,4.29-16.44,2.88-5.93,6.95-10.71,12.23-14.32s11.43-5.42,18.46-5.42c6.54,0,12.28,1.59,17.21,4.76,4.93,3.17,8.78,7.48,11.54,12.92,2.76,5.44,4.14,11.61,4.14,18.49h-67.85c-.06.94-.1,1.89-.11,2.86v8.13c0,.65.03,1.27.04,1.9h82.92v-6.81c0-9.86-1.35-18.3-4.06-25.3-2.71-7.01-6.35-12.75-10.91-17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m307.07,155.37c0-.96.05-1.91.11-2.86h-4.58v12.89h4.51c-.02-.63-.04-1.26-.04-1.9v-8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m488.97,172.8c0,6.93-1.52,12.72-4.54,17.36-3.03,4.64-6.84,8.13-11.46,10.47-4.61,2.34-9.29,3.51-14.03,3.51-7.76,0-14.11-2.57-19.04-7.73-4.93-5.15-7.39-12.02-7.39-20.61v-71.33h-14.79v72.28c0,9.18,1.57,16.85,4.72,23.03,3.15,6.18,7.5,10.83,13.03,13.95,5.54,3.13,11.87,4.69,19.01,4.69,8.35,0,15.35-1.94,21.01-5.82,5.66-3.88,9.81-8.7,12.45-14.46h1.03v18.82h14.79v-112.48h-14.79v68.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "554 202.09 617.2 116.41 617.2 104.48 536.13 104.48 536.13 118.32 598.16 118.32 598.16 119.34 533.64 205.46 533.64 216.96 619.39 216.96 619.39 203.11 554 203.11 554 202.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m697.38,156.18l-16.84-4.1c-6.84-1.7-11.89-3.96-15.16-6.77-3.28-2.8-4.91-6.5-4.91-11.09,0-5.37,2.38-9.77,7.14-13.22,4.76-3.44,10.8-5.16,18.12-5.16,5.08,0,9.29.81,12.63,2.42,3.35,1.61,6.04,3.73,8.09,6.37,2.05,2.64,3.61,5.47,4.69,8.49l13.4-3.73c-2.73-8.1-7.23-14.54-13.47-19.3-6.25-4.76-14.69-7.14-25.34-7.14-7.71,0-14.58,1.37-20.61,4.1-6.03,2.74-10.77,6.5-14.21,11.28-3.44,4.79-5.16,10.3-5.16,16.55,0,7.61,2.37,13.98,7.1,19.08,4.74,5.1,12.08,8.85,22.04,11.24l18.52,4.39c5.96,1.42,10.39,3.59,13.3,6.52,2.9,2.93,4.35,6.54,4.35,10.84,0,5.42-2.5,9.99-7.51,13.69-5.01,3.71-11.71,5.57-20.11,5.57-7.47,0-13.49-1.64-18.08-4.91-4.59-3.27-7.67-8.13-9.23-14.57l-14.06,3.51c2,9.47,6.64,16.69,13.92,21.64,7.27,4.96,16.5,7.44,27.68,7.44,8.44,0,15.87-1.43,22.26-4.28,6.39-2.86,11.39-6.77,14.98-11.76s5.38-10.67,5.38-17.06c0-7.66-2.4-13.99-7.18-18.97-4.79-4.98-12.04-8.66-21.75-11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m796.82,203.89c-1.22.22-2.73.33-4.54.33-2.78,0-5.41-.49-7.87-1.47-2.47-.97-4.47-2.74-6-5.31-1.54-2.56-2.31-6.23-2.31-11.02v-69.28h-14.72v73.01c0,6.3,1.46,11.56,4.36,15.78,2.9,4.22,6.62,7.39,11.13,9.48,4.52,2.1,9.19,3.15,14.03,3.15,2.93,0,5.37-.22,7.32-.66,1.95-.44,3.54-.9,4.76-1.39l-3.08-13.25c-.83.19-1.85.4-3.08.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 744.46,
    y: 104.47,
    width: 16.92,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 776.1,
    y: 104.47,
    width: 23.94,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 761.38,
    y: 104.47,
    width: 14.72,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 761.38,
    y: 77.53,
    width: 14.72,
    height: 26.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m835.78,64.79c-2.93,0-5.46,1-7.58,3-2.12,2-3.19,4.42-3.19,7.25s1.06,5.26,3.19,7.29c2.12,2.02,4.65,3.04,7.58,3.04s5.52-1.01,7.61-3.04c2.1-2.03,3.15-4.46,3.15-7.29s-1.05-5.25-3.15-7.25c-2.1-2-4.64-3-7.61-3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 828.31,
    y: 104.47,
    width: 14.72,
    height: 112.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.83,
    y: 104.47,
    width: 17.65,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 899.19,
    y: 104.47,
    width: 25.05,
    height: 12.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m914.94,60.02c-5.22,0-10.16,1.06-14.83,3.19-4.67,2.12-8.44,5.3-11.32,9.52-2.88,4.22-4.32,9.43-4.32,15.63v16.11h14.72v-12.81c0-5.76,1.43-10.16,4.28-13.22,2.86-3.05,7.14-4.58,12.85-4.58,2.3,0,4.18.19,5.64.59,1.47.39,2.66.73,3.59,1.02l4.25-12.81c-1.32-.54-3.19-1.11-5.6-1.72-2.42-.61-5.51-.91-9.26-.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 884.48,
    y: 104.47,
    width: 14.72,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 884.48,
    y: 117.14,
    width: 14.72,
    height: 99.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 971.84,
    y: 104.47,
    width: 23.95,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 940.2,
    y: 104.47,
    width: 16.92,
    height: 12.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 957.12,
    y: 77.53,
    width: 14.72,
    height: 26.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m992.56,203.89c-1.22.22-2.73.33-4.54.33-2.78,0-5.41-.49-7.87-1.47-2.47-.97-4.47-2.74-6.01-5.31-1.54-2.56-2.31-6.23-2.31-11.02v-69.28h-14.72v73.01c0,6.3,1.45,11.56,4.36,15.78,2.9,4.22,6.61,7.39,11.13,9.48,4.51,2.1,9.19,3.15,14.02,3.15,2.93,0,5.37-.22,7.33-.66,1.95-.44,3.54-.9,4.76-1.39l-3.08-13.25c-.83.19-1.85.4-3.07.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 957.12,
    y: 104.47,
    width: 14.72,
    height: 12.67
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreuzstiftRgbW);
export default __webpack_public_path__ + "static/media/Kreuzstift_RGB_W.5bfff4934b0daf87eebbcb7b0bbbe2b1.svg";
export { ForwardRef as ReactComponent };